module.exports = __webpack_public_path__ + "img/多边形.aeb88d55.png";